import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SubjectSelector.css';

function JuniorHighSubjects() {
  const navigate = useNavigate();

  const options = [
    {
      id: 'vocabulary',
      name: 'אוצר מילים',
      icon: '📚',
      description: 'משחקים לתרגול אוצר מילים',
      onClick: () => navigate('/junior-high/vocabulary')
    },
    {
      id: 'grammar',
      name: 'משחקי דקדוק',
      icon: '📘',
      description: 'משחקי דקדוק ותרגול נטיות',
      onClick: () => navigate('/junior-high/grammar')
    },
    {
      id: 'spoken',
      name: 'מדוברת',
      icon: '🗣️',
      description: 'תרגול הערבית המדוברת',
      onClick: () => navigate('/junior-high/spoken')
    }
  ];

  const handleBack = () => navigate('/');

  return (
    <div className="subject-selector junior-high">
      <div className="subject-selector-container junior-high">
        <div className="header-with-back junior-high">
          <button onClick={handleBack} className="back-to-grade-button" style={{ top: '-32px' }}>
            חזרה לבחירת שכבה ↩
          </button>
          <h2>חטיבת ביניים</h2>
        </div>

        <p className="subject-selector-subtitle junior-high">בחר את הנושא שברצונך ללמוד</p>

        <div className="subjects-grid">
          {options.map((opt) => (
            <div
              key={opt.id}
              className="subject-card"
              onClick={opt.onClick}
              style={{ '--subject-color': '#4CAF50' }}
            >
              <div className="subject-icon">{opt.icon}</div>
              <h3 className="subject-name">{opt.name}</h3>
              <p className="subject-description">{opt.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default JuniorHighSubjects;
